import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import { setBudgetSettingClient, initBudgetSettingClient } from "Actions";

import Item from "./Item";
import NotFoundV2 from "../NotFound/NotFoundV2";

class ClientsList extends Component {
  handleRedirectBudgetSetting = ({ id, name }, year) => {
    const { dispatch } = this.props;
    dispatch(initBudgetSettingClient());
    dispatch(setBudgetSettingClient({ id, name }));
    this.props.dispatch(
      push(`/budget-setting/?name=${name}&id=${id}&year=${year}`)
    );
  };

  render() {
    const { fetched, items, erpData, parameterSettings, fetching } = this.props;

    return (
      <div className="medium-12">
        {(fetched && !fetching) || items.length ? (
          items.map((item, i) => {
            return (
              <Item
                erpData={erpData}
                parameterSettings={parameterSettings}
                item={item}
                key={`client-${item.id}`}
                handleRedirectBudgetSetting={this.handleRedirectBudgetSetting}
                handleOpenClientEntitySetting={
                  this.props.handleOpenClientEntitySetting
                }
              />
            );
          })
        ) : (
          <NotFoundV2 />
        )}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetched: state.clients.list.fetched,
  fetching: state.clients.list.fetching
});

export default connect(mapStateToProps)(ClientsList);



// WEBPACK FOOTER //
// ./src/components/ClientsList/ClientsList.js